
<app-header />
<div class="layout-body">
  <app-sidebar role="nsc" />
  <main class="layout-content">
    <router-outlet />
  </main>
</div>
